import React from 'react'
import { inject } from 'mobx-react'
import type { AuthStore } from './types'
type DecoratorProps = {
  authStore: AuthStore
}

const withPermission =
  (permissionName: string) =>
  (WrappedComponent: any): any => {
    @inject('authStore')
    class Decorator extends React.PureComponent<DecoratorProps> {
      render() {
        const { authStore, ...props } = this.props
        return <WrappedComponent hasPermission={authStore.userHasPermission(permissionName)} {...props} />
      }
    }

    return Decorator
  }

export default withPermission
